<template>
  <nav class="h-[3.5rem] bg-paletteDarkGreen border-paletteDarkGreen z-50 border-b border-paletteLightGreen">
    <div class="flex flex-wrap items-center justify-between p-1">
      <!-- Logo and Brand Name -->
      <a href="/" class="flex items-center space-x-3 rtl:space-x-reverse">
        <img
          src="@/assets/logo.png"
          :alt="$t('headerBar.logoAlt')"
          class="h-12 rounded-lg"
        />
        <span class="self-center text-2xl font-semibold whitespace-nowrap text-white">
          {{ $t('headerBar.brandName') }}
        </span>
      </a>

      <!-- User menu + Hamburger button -->
      <div class="flex items-center xl:order-2">
        <UserMenu v-if="userStore.user" />

        <!-- Hamburger for small screens -->
        <button
          data-drawer-target="navbar-user"
          data-drawer-toggle="navbar-user"
          data-drawer-placement="right"
          type="button"
          class="inline-flex items-center ml-1 p-2 w-10 h-10 justify-center text-sm text-gray-200 rounded-xl xl:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
          aria-controls="navbar-user"
          aria-expanded="false"
        >
          <span class="sr-only">{{ $t('userMenu.openMainMenu') }}</span>
          <svg class="w-5 h-5" fill="none" viewBox="0 0 17 14" xmlns="http://www.w3.org/2000/svg">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M1 1h15M1 7h15M1 13h15" />
          </svg>
        </button>
      </div>

      <!-- Navbar drawer / menu items -->
      <div
        id="navbar-user"
        class="fixed top-[3.5em] right-0 z-40 w-64 xl:w-auto h-screen p-4 overflow-y-auto xl:overflow-visible transition-transform transform bg-paletteDarkGreen border-l border-paletteLightGreen xl:static xl:top-auto xl:right-auto xl:h-auto xl:p-0 xl:bg-transparent xl:border-0 xl:translate-x-0 translate-x-full"
        tabindex="-1"
        aria-labelledby="navbar-user-label"
      >
        <ul class="flex flex-col xl:flex-row xl:space-x-8 font-medium text-base text-white">
          <li v-for="item in menuItems" :key="item.to">
            <router-link
              :to="item.to"
              exact-active-class="text-paletteYellow font-bold border-b-4 border-paletteYellow"
              class="block pt-2 pb-1 px-3 rounded-sm transition hover:text-paletteYellow hover:bg-opacity-10 xl:hover:bg-transparent"
            >
              {{ $t(item.label) }}
            </router-link>
          </li>

          <!-- Auth links -->
          <template v-if="!userStore.user">
            <li>
              <router-link
                to="/login"
                exact-active-class="text-paletteYellow font-bold border-b-4 border-paletteYellow"
                class="block pt-2 pb-1 px-3 rounded-sm transition hover:text-paletteYellow hover:bg-opacity-10 xl:hover:bg-transparent"
              >
                {{ $t('headerBar.login') }}
              </router-link>
            </li>
            <li>
              <router-link
                to="/register"
                exact-active-class="text-paletteYellow font-bold border-b-4 border-paletteYellow"
                class="block pt-2 pb-1 px-3 rounded-sm transition hover:text-paletteYellow hover:bg-opacity-10 xl:hover:bg-transparent"
              >
                {{ $t('headerBar.register') }}
              </router-link>
            </li>
          </template>

          <!-- Language Switcher -->
          <li class="border-t pt-4 xl:pt-0 xl:border-0 border-gray-300">
            <LanguageSwitcher />
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import UserMenu from '@/components/layout/UserMenu.vue'
import { useUserStore } from '@/stores/users'
import LanguageSwitcher from './LanguageSwitcher.vue'
import { computed } from 'vue'

const userStore = useUserStore()

const menuItems = computed(() => [
  { to: '/', label: 'headerBar.home' },
  ...(userStore.user
    ? [{ to: '/conversation', label: 'headerBar.conversations' }]
    : [
        { to: '/pricing', label: 'headerBar.pricing' }
      ]),
  { to: '/about', label: 'headerBar.about' },
  { to: '/contact', label: 'headerBar.contact' }
])

</script>
